module.exports = __webpack_public_path__ + "img/codeforcause.0489fe57.webp";